import { Model } from "@westpierstudio/luma/mvc";
import { MultipliedWinsMap, PayLineWin, SymbolPos } from "servertypes/SharedTypes";
import { cloneDeep, orderBy } from "lodash";

export interface WinDisplayConfig {
    displayWinTime: number,
    timeBetweenWins: number
}

export type ScatterWin = {
    symbols: SymbolPos[],
    bonusWinnings: number
}

// export function isScatterWin(value: ScatterWin | PayLineWin) : value is ScatterWin {
//     return "symbols" in value;
// }

export class WinlinesModel extends Model {
    private wins: PayLineWin[] = [];
    private scatterWin?: ScatterWin;
    private lineIndex: number = 0;
    private scatterComplete: boolean = false;

    storeWins(wins: PayLineWin[], multipliedWinsMap?: MultipliedWinsMap): void {

        if (wins.length > 0) {

            this.wins = cloneDeep(wins);

            if (multipliedWinsMap) {

                for (const [i, item] of this.wins.entries()) {

                    if (multipliedWinsMap[i]) {
                        item.moneyWon = multipliedWinsMap[i].multipliedMoneyWon;
                    }
                }
            }

            this.wins = orderBy(this.wins, [`moneyWon`, `paylineIndex`], [`desc`, `asc`]);
            this.lineIndex = 0;
        } else {
            this.wins = [];
        }
    }

    storeScatterWin(symbols: SymbolPos[], bonusWinnings: number): void {

        this.scatterWin = {
            symbols: symbols,
            bonusWinnings: bonusWinnings
        };
    }

    nextWinLineData(): PayLineWin | undefined {

        if (!this.wins || this.lineIndex === this.lineCount) {
            return;
        }

        return this.wins[this.lineIndex++];
    }

    nextScatterWinData(): ScatterWin | undefined {

        if (this.scatterWin !== undefined && !this.scatterComplete) {
            this.scatterComplete = true;
            return this.scatterWin;
        }
    }

    resetLineIndex(): void {
        this.scatterComplete = false;
        this.lineIndex = 0;
    }

    override reset(): void {
        this.wins = [];
        this.scatterWin = undefined;
        this.resetLineIndex();
    }

    get lineCount(): number {

        return this.wins.length;
    }

    get hasScatterWin(): boolean {
        return this.scatterWin ? true : false;
    }
}